export class HttpError extends Error {
    constructor(public status: number, public statusText: string, public url: string) {
        super(`HTTP Error: ${status} ${statusText} on ${url}`);
    }
}